import {
  useApolloClient,
  useEmptyWorkspaceTrashMutation,
} from '@sketch/gql-types'
import { handleEmptiedWorkspaceTrash } from '../handlers'

export interface UseEmptyWorkspaceTrashProps {
  onCompleted: () => void
  onError: (message: string) => void
  identifier: string
}

export const useEmptyWorkspaceTrash = (props: UseEmptyWorkspaceTrashProps) => {
  const { onCompleted, onError, identifier } = props
  const client = useApolloClient()

  return useEmptyWorkspaceTrashMutation({
    variables: { identifier },
    onCompleted,
    update: () => {
      handleEmptiedWorkspaceTrash({ client, identifier })
    },
    onError: ({ message }) => {
      onError(message)
    },
  })
}
